var path = '/app-lite/stripe/stripe.status.html';
var html = "<div class=\"badge\"\n  data-ng-class=\"getClass()\">\n  <translate translate=\"COMPANY_SPACE.INTEGRATIONS.STRIPE.STATUS\"></translate>\n  :&nbsp;\n  <span data-ng-bind=\"status | stripeStatus\"></span>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;